export default __webpack_public_path__ + "static/media/mail-icon.3d672620.svg";